<template>
  
      <v-card elevation="0">
        <v-card-title>{{$t('components.qualityNotificationsCreationDialog.title')}}</v-card-title>
        <v-card-text>
          <v-row>
            <v-col :lg="6" :md="12">
              <v-select
                :items="selectableWorkOrders"
                v-model="selectedWorkOrderId"
                :label="$t('components.qualityNotificationsCreationDialog.workOrder')"
                outlined
              ></v-select>
            </v-col>
          </v-row>
          <!--<v-select
            v-model="catgeory_value"
            :items="['Lieferung', 'Montage', 'Beschädigung', 'sonstiges']"
            chips
            label="Kategorie"
            multiple
            outlined
          ></v-select>-->
          <v-textarea
            :label="$t('components.qualityNotificationsCreationDialog.note')"
            outlined
            :rows="8"
            v-model="problem"
          ></v-textarea>
          <v-file-input
            chips
            counter
            multiple
            show-size
            outlined
            :label="$t('components.qualityNotificationsCreationDialog.attachments')"
            :truncate-length="15"
            v-model="attachments"
            accept="image/jpg, image/png, video/mp4, video/mkv, audio/mp3, audio/ogg, application/pdf"
          ></v-file-input>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="sendQualityNotification()">{{$t('components.qualityNotificationsCreationDialog.send')}}<v-icon right>mdi-send</v-icon>
          </v-btn>
        </v-card-text>
      </v-card>
</template>

<script>
import dataAssembler from '../plugins/dataAssembler';
export default {
  name: "QualityNotificationsCreationDialog",
  data: function() {
    return {
      selectedWorkOrderId: 0,
      problem: "",
      attachments: [],

    }
  },
  props: {
    selectableWorkOrders: Array
  },
  methods: {
    sendQualityNotification: async function() {
      var qualityNotificationAndPositionDto = {
        ComplainedWorkOrderId: this.selectedWorkOrderId,
        Problem: this.problem,
        Attachments: []
      }

      for (let attachment of this.attachments) {
        qualityNotificationAndPositionDto.Attachments.push(
          {
            FileName: attachment.name,
            Base64Content: Buffer.from(await attachment.arrayBuffer()).toString('base64')
          }
        );
      }

      this.$http(
        dataAssembler.constructQualityNotificationCreationQuery(qualityNotificationAndPositionDto, this.$store.getters.customerNumber(), this.$store.getters.token())
      ).then((response) => {
        if (response.status === 200) {
          this.$emit('onQualityNotificationCreation', { success: true, message: 'Die Qualitätsmeldung wurde erfasst!', object: response  });
        }
      }).catch((error) => {
        console.error(error);
        this.$emit('onQualityNotificationCreation', { success: false, message: 'Beim Erfassen der Qualitätsmeldung ist ein Fehler aufgetreten!', object: error })
      });
    }
  }
};
</script>
